import { FechamentoAgendaInput } from 'graphql/types.generated'

import { FechamentoFormModel } from './model'

export default function fechamentoAgendaConvert(model: FechamentoFormModel, idLotacao: ID): FechamentoAgendaInput {
  return (
    model && {
      idLotacao: idLotacao,
      periodo: model.periodo,
      motivo: model.motivo,
      especifique: model.especifique,
    }
  )
}
